module.exports = __webpack_public_path__ + "static/earth-ffcc5b238d5ddfe3ebca40538d8dc6e3.gif";